import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
  showCast?: boolean;
}

export default function MovieCard({ movie, showCast = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} - 爱情电影介绍与影评`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 right-2 px-2 py-1 rounded-md bg-foreground-950/70 text-accent-400 text-xs font-bold flex items-center gap-1">
          <i className="ri-star-fill text-xs"></i>
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-0 left-0 right-0 px-3 py-2 bg-gradient-to-t from-foreground-950/80 to-transparent flex items-center gap-2">
          {movie.genres.slice(0, 2).map((g) => (
            <span key={g} className="text-[11px] text-background-100 whitespace-nowrap">
              {g}
            </span>
          ))}
        </div>
      </div>
      <div className="p-3 flex flex-col gap-1.5">
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="w-1 h-1 rounded-full bg-background-400"></span>
          <span className="truncate">{movie.region}</span>
        </div>
        {showCast && (
          <p className="text-xs text-foreground-600 line-clamp-1">
            主演：{movie.cast.join(" / ")}
          </p>
        )}
      </div>
    </Link>
  );
}